module.exports = __webpack_public_path__ + "img/1557614069556518915.27c110d1.png";